import React from 'react';
import { Inspector } from '@quintype/em/components/inspector';
import Select from '@quintype/em/components/select';

export function InvoiceFilters (props) {
  return (
    <div>
      <Inspector title='Filters' isActive={props.opened} onClose={() => props.onClose()} actionButtonLabel='Apply Filters' onActionButtonClick={e => props.onActionButtonClick(e)}>
        <Select
          label='Subscription Groups'
          options={props.groups}
          onChange={(e) => props.onChangeGroup(e)}
          value={props.groupValue}
        />
        <Select
          label='Subscription Plans'
          options={props.plans}
          onChange={(e) => props.onChangePlan(e)}
          value={props.planValue}
        />
      </Inspector>
    </div>);
}
